export default defineNuxtPlugin(async () => {
  const { isHina } = useServiceType()
  if (isHina) {
    // ひなぎくの場合は過去の震災のIDのリクエストかもしれないのでチェックする
    let isTargetLangJa = true
    const href = window.location.href
    let issTokenMatch = href.match(/https?:\/\/.*?\/(en\/)?#\/part\/(R[0-9]*-I[0-9]*-[0-9]*)/)
    // 震災のISSトークンが取得出来たらリダイレクトの設定確認する
    if (issTokenMatch && issTokenMatch.length === 3) {
      const { getItemRedirect } = useItemRedirect()
      let issToken = issTokenMatch[2]
      try {
        const itemRedirect: RedirectAPIResponse = await getItemRedirect(issToken)
        if (itemRedirect) {
          if (issTokenMatch[1]) {
            isTargetLangJa = false
          }
          // リダイレクト設定あるのでリダイレクトする
          window.location.href = `/${isTargetLangJa ? '' : 'en/'}item/${itemRedirect.itemId}`
        }
      } catch (e) {
        const errorStore = useErrorStore()
        errorStore.setDapError(404, '/', href)
        showError(errorStore.createDapError())
      }
    }
  }
})
